/**
 * La distance entre deux points, a vol d'oiseau.
 *
 * # Pourquoi ici, et pas dans la base
 *
 * La Realtime Database ne sait pas interroger un rayon : il faudrait un
 * geohash et une branche de plus a tenir a jour. La liste d'un spot tient
 * en memoire — c'est deja ce qui permet de filtrer par categorie sans
 * repasser par le reseau — donc le rayon se calcule au meme endroit et
 * repond au doigt.
 *
 * # A vol d'oiseau, et c'est assez
 *
 * Personne ne compare « 9,2 km » a « 10,4 km » : on veut savoir si une
 * sortie est dans le quartier, dans la ville, ou a l'autre bout de la
 * region. Un vrai temps de trajet demanderait un service de routage, une
 * cle, et une requete par evenement.
 */

export interface Point {
  lat: number;
  lon: number;
}

/*
  Le rayon moyen de la Terre. La formule de haversine la prend pour une
  sphere : l'ecart avec l'ellipsoide reel vaut trois millimetres par
  kilometre, sans effet sur un choix entre 25 et 50 km.
*/
const RAYON_TERRE_KM = 6371;

const EN_RADIANS = Math.PI / 180;

/** Les kilometres qui separent deux points. */
export function distanceKm(a: Point, b: Point): number {
  const dLat = (b.lat - a.lat) * EN_RADIANS;
  const dLon = (b.lon - a.lon) * EN_RADIANS;
  const h =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(a.lat * EN_RADIANS) * Math.cos(b.lat * EN_RADIANS) * Math.sin(dLon / 2) ** 2;
  /*
    `Math.min(1, ...)` garde l'arc sinus dans son domaine : deux points
    diametralement opposes donnent une racine qui depasse 1 d'un cheveu
    par arrondi, et `Math.asin` rendrait alors `NaN`.
  */
  return 2 * RAYON_TERRE_KM * Math.asin(Math.min(1, Math.sqrt(h)));
}
